<template>
  <div>
    <Counter ref="cnt" v-show="isCounter" :from="counter" v-on:end="next" />
    <Workout :key="currentTraining.name" ref="workout" :list="currentTrainingWorkouts" :rep="currentTraining.repetitions.length" @progress="progress" @end="end" @playing="setPlaying" class="m-t-md">
    </Workout>
  </div>
</template>

<script>
import Workout from '@/components/Settings/WorkoutM2'
import Counter from '@/components/Settings/Counter'


export default {
  name: 'TrainingEmpty',
  data () {
    let currentTraining = {}
    if (this.$route.query.tn !== undefined) {
      currentTraining = this.$store.getters.getTrainingByName(this.$route.query.tn) || {}
    }

    if (currentTraining.name === undefined && this.$store.getters.getCurrentTrainingName) {
      currentTraining = this.$store.getters.getTrainingByName(this.$store.getters.getCurrentTrainingName)
    } else if (currentTraining.name === undefined) {
      currentTraining = this.$store.getters.getRandomTraining(1)
      this.$store.commit('updateCurrentTrainingName', currentTraining.name)
    }
    return {
      current: 0,
      currentTime: 0,
      workoutTime: 0,
      currentWorkoutTime: 0,
      currentTraining,
      isCounter: false,
      counter: 10,
      playing: false,
      currentTrainingWorkouts: currentTraining.workouts,
      exampleIsActive: false,
      exampleVideoSrc: null,
      exampleVideoPoster: null,
      exampleKey: Math.random()
    }
  },
  computed: {
    fullTimeInMinute() {
      return Math.floor(this.fullTime/60) + ':' + ('0' + this.fullTime%60).slice(-2)
    },
    fullTime () {
      return this.currentTrainingWorkouts.reduce((sum, item) => sum + item.duration, 0) * this.currentTraining.repetitions.length + 10 * (this.currentTraining.repetitions.length * this.currentTrainingWorkouts.length - 1)
    },
    countWorkout () {
      return this.currentTrainingWorkouts.length * this.currentTraining.repetitions.length
    }
  },
  methods: {
    progress(obj) {
      this.current = obj.current
      this.currentTime = obj.currentTime,
      this.workoutTime = obj.workoutTime
      this.isCounter = obj.counter
      this.currentWorkoutTime = obj.currentWorkoutTime
      if (obj.counter) {
        this.$refs.cnt.start(10)
      }
    },
    playPause() {
      this.$scrollToTop(100)
      this.$refs.workout.playPause()
    },
    resume() {
      this.playPause()
    },
    save() {
      this.$router.push({ name: 'Home' })
    },
    stop() {
      this.$store.commit('setWorkoutNumber', 0)
      this.$router.push({ name: 'Home' })
    },
    next() {
      this.isCounter = false
      this.counter = 10
      this.playPause()
    },
    end() {
      console.log(this.currentTraining.name)
      if (this.currentTraining.isTraining) {
        this.$router.push({ name: 'TrainingEnd' })
      } else {
        this.$router.push({ name: 'Training' })
        if (this.$store.getters.getCurrentTrainingName) {
          this.currentTraining = this.$store.getters.getTrainingByName(this.$store.getters.getCurrentTrainingName)
        } else {
          this.currentTraining = this.$store.getters.getRandomTraining(1)
          this.$store.commit('updateCurrentTrainingName', this.currentTraining.name)
        }
        this.currentTrainingWorkouts = this.currentTraining.workouts
        this.current = 0
        this.currentTime = 0
        this.workoutTime = 0
        this.currentWorkoutTime = 0
      }
    },
    setPlaying (playing) {
      return this.playing = playing
    },
    showExample (example) {
      this.$router.push({ name: 'Training', query: {
        tn: example.name
      } })
      this.currentTraining = this.$store.getters.getTrainingByName(example.name)
      this.currentTrainingWorkouts = this.currentTraining.workouts
      this.current = 0
      this.currentTime = 0
      this.workoutTime = 0
      this.currentWorkoutTime = 0
      /*this.exampleVideoSrc = example.vidpath === undefined ? 'http://assets.keepyou.fit/fitness/vid/'+example.vidname+'.mp4' : example.vidpath
      this.exampleVideoPoster = example.preview
      this.exampleIsActive = true
      this.$refs.example.play()*/
    }
  },
  components: {
    Workout,
    Counter
  }
}
</script>

<style>
.preview {
  display: inline-block;
  margin: 0.5rem 1rem;
  border-radius: 0.5rem;
}
.play {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -16px;
  margin-top: -16px;
}
</style>





// WEBPACK FOOTER //
// src/components/Settings/TrainingEmpty.vue